import { type CompanyData, type CompanyKind } from '../model'
import { isDeleted } from './common'

const FAKE_COMPANY_KINDS: CompanyKind[] = ['demo', 'sandbox', 'template', 'development']
const FROZEN_COMPANY_KINDS: CompanyKind[] = ['demo', 'template']
const EXAMPLE_EMAIL_REQUIRED_KINDS: CompanyKind[] = ['demo', 'template', 'development']

type CompanyKindInput = Pick<CompanyData, 'kind'>

export function isFakeCompany(company?: CompanyKindInput): boolean {
  if (!company) return false
  return FAKE_COMPANY_KINDS.includes(company.kind)
}

export function isRealCompany(company?: CompanyKindInput): boolean {
  if (!company) return false
  return !FAKE_COMPANY_KINDS.includes(company.kind)
}

export function isFrozenCompany(company?: CompanyKindInput): boolean {
  if (!company) return false
  return FROZEN_COMPANY_KINDS.includes(company.kind)
}

export function requiresExampleEmail(company?: CompanyKindInput): boolean {
  if (!company) return false
  return EXAMPLE_EMAIL_REQUIRED_KINDS.includes(company.kind)
}

type CompanyAccessInput = Pick<CompanyData, 'isDeleted' | 'accessStatus' | 'accessOverride'>

export function isCompanyActive(company: CompanyAccessInput): boolean {
  if (isDeleted(company)) return false
  const override = company.accessOverride
  if (override && override.expiresAt > Date.now()) return override.accessStatus === 'active'
  return company.accessStatus === 'active'
}

export function isCompanySuspended(company: CompanyAccessInput): boolean {
  return !isCompanyActive(company)
}

type ActiveCustomerInput = CompanyKindInput & Pick<CompanyData, 'accessStatus' | 'accessOverride' | 'isDeleted'>

export function isActiveCustomer(company: ActiveCustomerInput): boolean {
  return company.kind === 'customer' && isCompanyActive(company)
}

export function isStripeManagedCompany(company: Pick<CompanyData, 'billingMethod'>): boolean {
  return company.billingMethod === 'stripe'
}
